import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Logo from "../../Imagens/logoPentagov.jpg";
import api from "../../Services/api";
import InputMask from "react-input-mask"; // 👈 import da lib
import "./styles.css";

const CadastroOperadorExterno = () => {
  const { idCliente } = useParams();
  const [cadastroConcluido, setCadastroConcluido] = useState(false);

  const [formData, setFormData] = useState({
    nome: "",
    cpf: "",
    email: "",
    senha: "",
    codigovalida: idCliente,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Remove máscara do CPF antes de enviar
    const cpfSemMascara = formData.cpf.replace(/\D/g, "");

    const body = {
      ...formData,
      cpf: cpfSemMascara,
      IDCliente: Number(idCliente),
      situacao: 0,
      dataCadastro: new Date().toISOString().slice(0, 19).replace("T", " ")
    };

    try {
      const res = await api.post("/cadOperadorExterno", body);
      Swal.fire({
        icon: "success",
        title: "Cadastro realizado com sucesso!",
        text: `ID do Operador: ${res.data.IDOperadorexterno}`,
      });
      setFormData({
        nome: "",
        cpf: "",
        email: "",
        senha: "",
        codigovalida: idCliente,
      });

      // ativa tela de sucesso
      setCadastroConcluido(true);

    } catch (err) {
      console.error("❌ Erro ao cadastrar operador externo:", err);

      let msg = "Erro inesperado ao cadastrar operador.";

      if (err.response?.data?.errors) {
        const errors = err.response.data.errors;

        // Se for objeto com vários campos, concatena
        if (typeof errors === "object") {
          msg = Object.values(errors).join("\n");
        } else {
          msg = errors;
        }
      }

      Swal.fire("Erro", msg, "error");
    }

  };

  if (cadastroConcluido) {
    return (
      <div className="sucesso-fullscreen">
        <div className="sucesso-logo-area">
          <img src={Logo} alt="Logo PentaGOV" className="sucesso-logo" />
        </div>

        <div className="sucesso-card">
          <h3>Cadastro realizado com sucesso!</h3>
          <p>
            Cadastro realizado com sucesso, aguarde a aprovação do administrador do sistema.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="cadastro-container">
      <div className="logo-container">
        <img src={Logo} alt="Logo PentaGOV" className="logo" />
      </div>

      <div className="cadastro-painel">
        <h3 className="text-center mb-4">Cadastro de Operador</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label>Nome</label>
            <input
              type="text"
              name="nome"
              className="form-control"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>

          {/* CPF com máscara */}
          <div className="form-group mb-3">
            <label>CPF</label>
            <InputMask
              mask="999.999.999-99"
              name="cpf"
              value={formData.cpf}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          {/* Email com validação nativa */}
          <div className="form-group mb-3">
            <label>E-mail</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="exemplo@dominio.com"
            />
          </div>

          <div className="form-group mb-3">
            <label>Senha</label>
            <input
              type="password"
              name="senha"
              className="form-control"
              value={formData.senha}
              onChange={handleChange}
              required
              maxLength={10}
            />
          </div>
          {/*
          <div className="form-group mb-3">
            <label>Código de Validação</label>
            <input
              type="text"
              name="codigovalida"
              className="form-control"
              value={formData.codigovalida}
              onChange={handleChange}
              required
            />
          </div>
           */}

          <button type="submit" className="btn btn-primary w-100 mt-2">
            Cadastrar
          </button>
        </form>
      </div>
    </div>
  );
};

export default CadastroOperadorExterno;
